enum FriendInviteStatus {
    VALID = 'Valid',
    EXPIRED = 'Expired',
    CONSUMED = 'Consumed',
    SENDER_BLOCKED_RECIPIENT = 'SenderBlockedRecipient',
    INVALID = 'Invalid'
}

export default FriendInviteStatus;
